import { applyAllValidators } from 'utils/formValidators';

export default (values) => ({ values, errors: applyAllValidators(values, {}) });
